
  import { defineComponent, nextTick, onMounted, ref, toRefs } from 'vue';
  // @ts-ignore
  import { BTooltip } from 'buefy/dist/esm/tooltip';
  import { t } from '@/ui/i18n/i18n';

  interface ListTruncatedCellProps {
    index: number;
    cellText: string;
    identifier: string;
  }

  export default defineComponent<ListTruncatedCellProps>({
    name: 'ListTruncatedCell',
    components: {
      BTooltip,
    },
    props: ['index', 'cellText', 'identifier'],
    setup(props) {
      const { index, cellText } = toRefs(props);
      const uniqueKey = `${props.identifier}-${index!.value}`;
      const isTruncated = ref<{ [key: string]: boolean }>({});

      const fieldCellText = cellText.value.replace(', ,', `, ${t('common.no-title')},`);

      const checkOverflow = async (key: string) => {
        await nextTick();
        const el = document.querySelector(`.truncated-element-${key}`) as HTMLElement;

        if (el) {
          isTruncated.value = { ...isTruncated.value, [key]: el.scrollHeight > el.clientHeight };
        }
      };

      onMounted(() => {
        nextTick(() => {
          checkOverflow(uniqueKey);
        });
      });

      return {
        fieldCellText,
        uniqueKey,
        isTruncated,
        checkOverflow,
      };
    },
  });
